import React, { Component } from 'react'
import { captureException } from '@sentry/browser'
import { Redirect } from 'react-router-dom'
import { t } from '@lingui/macro'

import { get } from 'lodash'
import ErrorMessage from '../../components/common/error/ErrorMessage'
import { linkBuilder } from 'shared/linkBuilder'

export interface IErrorBoundaryProps {
  topicId: number
}

export interface IErrorBoundaryState {
  error?: Error
}

export class TopicEditErrorBoundary extends Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  static defaultProps = {
    message: t`Failed to load the resource`
  }

  state: IErrorBoundaryState = {}

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error) {
    captureException(error)
  }

  render() {
    const { children, topicId } = this.props
    const { error } = this.state

    if (error) {
      if (get(error, 'graphQLErrors[0].path[1]') === 'draftVersion') {
        // TODO put into a specific
        return <Redirect to={linkBuilder.topicUrl(topicId)} />
      }

      return <ErrorMessage error={error} />
    }

    return children
  }
}
